import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { Box } from "../Box";
import { BunnySlider, BarBackground, BarProgress, BunnyButt, StyledInput, SliderLabel, SliderLabelContainer } from "./styles";
var Slider = function(_param) {
    var name = _param.name, min = _param.min, max = _param.max, value = _param.value, onValueChanged = _param.onValueChanged, valueLabel = _param.valueLabel, _step = _param.step, step = _step === void 0 ? "any" : _step, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, props = _object_without_properties(_param, [
        "name",
        "min",
        "max",
        "value",
        "onValueChanged",
        "valueLabel",
        "step",
        "disabled"
    ]);
    var handleChange = useCallback(function(param) {
        var target = param.target;
        onValueChanged(parseFloat(target.value));
    }, [
        onValueChanged
    ]);
    var progressPercentage = value / max * 100;
    var isMax = value === max;
    // let progressWidth: string;
    // if (progressPercentage <= 10) {
    //   progressWidth = `${progressPercentage + 0.5}%`;
    // } else if (progressPercentage >= 90) {
    //   progressWidth = `${progressPercentage - 4}%`;
    // } else if (progressPercentage >= 60) {
    //   progressWidth = `${progressPercentage - 2.5}%`;
    // } else {
    //   progressWidth = `${progressPercentage}%`;
    // }
    var labelProgress = isMax ? "calc(100% - 12px)" : "".concat(progressPercentage - 6, "%");
    var displayValueLabel = isMax ? "MAX" : valueLabel;
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        position: "relative",
        height: "48px"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(BunnyButt, {
                disabled: disabled
            }),
            /*#__PURE__*/ _jsxs(BunnySlider, {
                children: [
                    /*#__PURE__*/ _jsx(BarBackground, {
                        disabled: disabled
                    }),
                    /*#__PURE__*/ _jsx(BarProgress, {
                        style: {
                            width: "".concat(progressPercentage, "%")
                        },
                        disabled: disabled
                    }),
                    /*#__PURE__*/ _jsx(StyledInput, {
                        name: name,
                        type: "range",
                        min: min,
                        max: max,
                        value: value,
                        step: step,
                        onChange: handleChange,
                        isMax: isMax,
                        disabled: disabled
                    })
                ]
            }),
            valueLabel && /*#__PURE__*/ _jsx(SliderLabelContainer, {
                children: /*#__PURE__*/ _jsx(SliderLabel, {
                    progress: labelProgress,
                    children: displayValueLabel
                })
            })
        ]
    }));
};
export default Slider;
